<template>
  <div class="media_nav">
    <img src="./../../assets/daohang.png" alt class="menu_logo" @click="toggleClick" />
    <!-- 这里显示路由名称或者导航 -->
    <div class="title">{{$route.meta.title}}</div>
  </div>
</template>

<script>
export default {
  name: "MediaHader",
  data() {
    return {
      content: "移动端显示"
    };
  },
  created(){
  },
  methods: {
    toggleClick() {
      this.$emit("toggleClick");
    }
  }
};
</script>

<style lang="scss" scoped>
.media_nav {
  width: 100%;
  height: 46px;
  line-height: 46px;
  padding: 0 1rem;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.05);
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .menu_logo {
    width: 24px;
    cursor: pointer;
  }
  .title {
    flex: 1;
    font-size: 20px;
    color: #333;
    margin-left: 10px;
  }
}
</style>